import { formatAddressSlug } from '@mollusk/shared';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { api } from '../api/endpoints';
import { HomeView } from '../features/home/HomeView';
import { AddressSearchBox } from '../features/search/AddressSearchBox';
import { SearchBox } from '../features/search/SearchBox';

const EXAMPLES = ['500 W 2nd St, Austin, TX 78701', '4500 Avenue G, Austin, TX 78751'];

function HomePage() {
  const navigate = useNavigate();
  const stats = useQuery({ queryKey: ['coverage-stats'], queryFn: api.coverageStats });
  return (
    <HomeView
      stats={stats.data}
      onNavigate={(to) => navigate({ to })}
      search={
        <Box sx={{ maxWidth: 720 }}>
          <SearchBox
            address={<AddressSearchBox />}
            onSearch={(s) => navigate({ to: '/search', search: s })}
          />
          <Typography variant="body2" color="text.secondary">
            Try:{' '}
            {EXAMPLES.map((e, i) => (
              <span key={e}>
                {i > 0 ? ' · ' : ''}
                <Link
                  component="button"
                  variant="body2"
                  onClick={() =>
                    navigate({ to: '/address/$slug', params: { slug: formatAddressSlug(e) } })
                  }
                >
                  {e}
                </Link>
              </span>
            ))}
          </Typography>
        </Box>
      }
    />
  );
}

export const Route = createFileRoute('/')({
  component: HomePage,
  validateSearch: () => ({}) as Record<string, never>,
});
